import React from 'react';
import PropTypes from 'prop-types';
import { ModalContent, BottomSection } from './styles';
import PreviewResume from './PreviewResume';
import { URLS } from 'consts';
import Button from 'components/ui/buttons/Button';
import ButtonLink from 'components/ui/buttons/ButtonLink';
import Dialog from 'components/ui/Dialog';
import { activateLoader } from 'utilities';
import Caret from 'components/ui/icons/Caret';

const ResumeModal = props => {
  // This is a temporary measure to save the bid as a draft when
  // navigating to a profile section. Remove this when the bids
  // page is refactored to react.
  const saveDraftAndRedirect = destinationUrl => {
    if (props.isBidSource) {
      activateLoader();
      window.Bid.submitBid(true); // true for Draft
      setTimeout(() => {
        window.location = destinationUrl;
      }, 1000);
    } else {
      window.location = destinationUrl;
    }
  };
  const handleDownloadResume = () => {
    window.open(URLS.talentGeneratedResume);
  };

  const resumeAction = () => {
    let action = (
      <Button id="download-resume" onClick={handleDownloadResume}>
        Download Resume
      </Button>
    );

    if (props.isBidSource) {
      action = (
        <Button id="use-generated-resume" onClick={props.handleUseResume}>
          Use This Resume
        </Button>
      );
    }

    if (props.context === 'uploaded') {
      action = null;
    }

    return action;
  };

  return (
    <Dialog large onHide={props.handleClose} show={true}>
      <ModalContent>
        <PreviewResume
          {...props}
          context={props.context}
          saveDraftAndRedirect={saveDraftAndRedirect}
        />
        <BottomSection {...props}>
          {props.isBidSource ? (
            <div className="link-section">
              Not satisfied with this resume? Save this bid as a draft and&nbsp;
              <ButtonLink
                data-id="update-profile-btn"
                onClick={() => saveDraftAndRedirect(URLS.talentProfile)}
              >
                update your profile&nbsp;
                <Caret />
              </ButtonLink>
            </div>
          ) : null}
          {resumeAction()}
        </BottomSection>
      </ModalContent>
    </Dialog>
  );
};

ResumeModal.propTypes = {
  context: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  handleUseResume: PropTypes.func,
  isBidSource: PropTypes.bool,
};

export default ResumeModal;
